import { Component, OnInit, Input, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { HomepageService } from '../../../shared/services/homepage/homepage.service';
import { EventsService, UtilService, VariablesService } from '../../../shared/services';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent implements OnInit, AfterViewInit {

  @Input() section;
  @Input() count;
  isLoading = false;
  activeBanner;
  banners;
  @ViewChild('whatsAppSticky', { static: true }) public whatsAppSticky: ElementRef<HTMLElement>;
  bannerServiceObservable: Subscription;
  constructor(
    public utilService: UtilService,
    public vars: VariablesService,
    private eventService: EventsService,
    private homepageService: HomepageService
  ) { }

  ngOnInit() {
    // this.animateBanner();
    this.getBanner();
  }

  getBanner() {
    this.bannerServiceObservable = this.homepageService.getBanner().subscribe(
      (res: any) => {
        this.activeBanner = res.data.data[0];
        this.banners = res.data.data;
      }
    );
  }


  ngAfterViewInit() {
    this.animateBanner();
  }

  animateBanner() {
    if (this.utilService.isBrowser) {
      const stage = document.getElementById('medical-banner-slide');
      const arr = stage.getElementsByTagName('a');
      const fadeComplete = () => { stage.appendChild(arr[0]); };
      Array.prototype.forEach.call(arr, item => item.addEventListener('animationend', fadeComplete, false));
    }
  }

  systemEvent(event) {
    const payload = {
      eventName: 'wa_chat_with_us',
      event_type: 'campaign',
      info_1: 'type',
      page_name: this.vars.pageName,
      info_2: 9
    };
    this.eventService.sendSystemEvent(payload).subscribe(() => {
    });
    this.eventService.userGTMEvents({
      event: 'chat_click',
      event_category: 'navigation',
      event_action: 'whatsapp chat click',
      event_label: `${event.target.innerText}|body`
    });
  }
  /*sticky donate button */
  whatsappToggle(event) {
    if (this.banners?.length && this.whatsAppSticky) {
      if (event.visible === true) {
        this.whatsAppSticky.nativeElement.children[0].classList.remove('whatsapp-share-sticky');
        this.whatsAppSticky.nativeElement.children[0].classList.add('whatsapp-share-unstick');
      } else if (event.visible === false) {
        this.whatsAppSticky.nativeElement.children[0].classList.add('whatsapp-share-sticky');
        this.whatsAppSticky.nativeElement.children[0].classList.remove('whatsapp-share-unstick');
      }
    }
  }

  /*Events for whatsapp mobile */
  pushWhatsappEvent(event) {
    this.eventService.userGTMEvents({
      event: 'chat_click',
      event_category: 'navigation',
      event_action: 'whatsapp chat click',
      event_label: `${event.target.innerText}|body`
    });
    const payload = {
      eventName: 'wa_chat_with_us',
      event_type: 'campaign',
      info_1: 'type',
      info_2: 6
    };
    this.eventService.sendSystemEvent(payload).pipe(first()).subscribe((data) => {
      this.openWhatsApp();
    }, () => this.openWhatsApp());
  }

  openWhatsApp() {
    if (typeof window !== 'undefined') {
      const url = 'https://api.whatsapp.com/send?phone=91' + this.vars.contactUsMobNumber + '&text=Hi,%20I%20am%20looking%20to%20start%20a%20fundraiser%20on%20Ketto';
      const target = window.navigator.userAgent.match('Firefox|Safari') ? '_self' : '_blank';
      window.open(url, target);
    }
  }

}
